import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { APP_CONFIG } from '../../app.config';
import { AgeService } from '../../common/age.service';
import { AntragService } from '../../common/antrag.service';
import { Ap2ModeService } from '../../common/ap2mode.service';
import { DocumentService } from '../../common/document.service';
import { ErrorCode, PresentationMode } from '../../common/enums';
import { FingerabdruckService } from '../../common/fingerabdruck.service';
import { InfoService } from '../../common/info.service';
import { LichtbildService } from '../../common/lichtbild.service';
import { ScankomponenteService } from '../../common/scan-component.service';
import { ValidationService } from '../../common/validation.service';
import { ValueListsService } from '../../common/value-lists.service';
import { AppConfig } from '../../models/config/app-config';

@Component({
  selector: 'app-cfg-visum',
  templateUrl: './cfg-visum.component.html',
  providers: [
    AntragService,
    Ap2ModeService,
    FingerabdruckService,
    AgeService,
    LichtbildService,
    ValueListsService,
    InfoService
  ]

})
export class CfgVisumComponent implements OnInit {

  valuelistsPreloaded = false;
  validationMetadataPreloaded = false;
  lichtbildDevicesPreloaded = false;
  fingerabdruckDevicesPreloaded = false;
  scannerSettingsPreloaded = false;
  documentSettingsPreloaded = false;
  ap2ModePreloaded = false;
  private readonly destroyRef = inject(DestroyRef);

  errorCodes: ErrorCode[] = [];

  constructor(
    private titleService: Title,
    private valuelistService: ValueListsService,
    private validationService: ValidationService,
    private lichtbildService: LichtbildService,
    private fingerabdruckService: FingerabdruckService,
    private scankomponenteService: ScankomponenteService,
    private documentService: DocumentService,
    private ap2ModeService: Ap2ModeService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {

    this.valuelistService.fetchLists().subscribe(
      {
        next: () => this.valuelistsPreloaded = true,
        error: error => {
          console.error(error.error.message);
          this.addErrorCode(ErrorCode.LOAD_VALUELISTS_ERROR);
        }
      });

    this.validationService.getValidationMetadata$()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe({
      next: () => this.validationMetadataPreloaded = true,
      error: error => {
        console.error(error.error.message);
        this.addErrorCode(ErrorCode.LOAD_VALIDATION_METADATA_ERROR);
      }
    });

    if (this.appConfig.umgebung === 'MEK') {
      this.lichtbildService.fetchLichtbildDevices().subscribe({
        next: () => this.lichtbildDevicesPreloaded = true,
        error: error => {
          console.error(error.error.message);
          this.addErrorCode(ErrorCode.LOAD_DEVICES_ERROR);
        }
      });

      this.fingerabdruckService.fetchFingerabdruckDevices().subscribe({
        next: () => this.fingerabdruckDevicesPreloaded = true,
        error: error => {
          console.error(error.error.message);
          this.addErrorCode(ErrorCode.LOAD_DEVICES_ERROR);
        }
      });

      this.scankomponenteService.fetchSettings().subscribe({
        next: () => this.scannerSettingsPreloaded = true
      });
      this.documentService.fetchSettings().subscribe({
        next: () => this.documentSettingsPreloaded = true
      });

      this.ap2ModeService.isAp2Mode().subscribe({
        next: (isAp2Mode) => {
          this.appConfig.presentationMode = isAp2Mode ? PresentationMode.AP2 : PresentationMode.DEFAULT;
          this.ap2ModePreloaded = true;
        },
        error: error => {
          console.error(error.error.message);
          this.addErrorCode(ErrorCode.LOAD_IS_AP2_MODE_ERROR);
        }
      });
    }
  }

  ngOnInit() {
    const newTitle = this.appConfig.umgebung || '';
    this.titleService.setTitle(newTitle);
  }

  isEverythingPreloaded() {
    if (this.appConfig.umgebung === 'VIDEX') {
      return this.valuelistsPreloaded && this.validationMetadataPreloaded;
    } else {
      return this.valuelistsPreloaded && this.validationMetadataPreloaded &&
        this.lichtbildDevicesPreloaded &&
        this.fingerabdruckDevicesPreloaded &&
        this.scannerSettingsPreloaded &&
        this.documentSettingsPreloaded &&
        this.ap2ModePreloaded;
    }
  }

  addErrorCode(code) {
    if (this.errorCodes.indexOf(code) < 0) {
      this.errorCodes.push(code);
    }
  }

}
